"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accordion = void 0;
const accordion = () => {
    let accordions = document.querySelectorAll('[data-accordion="wrap"]');
    for (let accordion of accordions) {
        function open(button, panel) {
            button.setAttribute('aria-expanded', 'true');
            button.classList.add('is-open');
            panel.classList.add('is-visible');
            let panelHeight = panel.querySelector('.accordion__content').offsetHeight;
            panel.setAttribute('style', 'height: ' + panelHeight + 'px');
        }
        function close(button, panel) {
            button.setAttribute('aria-expanded', 'false');
            button.classList.remove('is-open');
            panel.classList.remove('is-visible');
            panel.setAttribute('style', 'height: 0px');
        }
        // const panels = accordion.querySelectorAll('[data-accordion="panel"]') as NodeListOf<Element>;
        // const buttons = accordion.querySelectorAll('[data-accordion="button"]') as NodeListOf<Element>;
        //
        // let firstPanel = panels.item(0);
        // let firstButton = buttons.item(0);
        //
        // open(firstButton, firstPanel);
        document.addEventListener('click', function (event) {
            const target = event.target;
            if (!target.matches('[data-accordion="button"]')) {
                return;
            }
            let item = target.getAttribute('data-toggle');
            let currentPanel = accordion.querySelector('[data-content=' + item + ']');
            if (currentPanel.classList.contains('is-visible')) {
                close(target, currentPanel);
            }
            else {
                open(target, currentPanel);
            }
        });
    }
};
exports.accordion = accordion;
